import { common } from '@/locales/fr-FR/common';
import { auth } from '@/locales/fr-FR/auth';
import { navigation } from '@/locales/fr-FR/navigation';
import { profile } from '@/locales/fr-FR/profile';
import { workspace } from '@/locales/fr-FR/workspace';
import { billing } from '@/locales/fr-FR/billing';
import { work } from '@/locales/fr-FR/work';
import { assets } from '@/locales/fr-FR/assets';
import { inspections } from '@/locales/fr-FR/inspections';
import { jobs } from '@/locales/fr-FR/jobs';
import { lifecycleGate } from '@/locales/fr-FR/lifecycleGate';
import { contacts } from '@/locales/fr-FR/contacts';
import { copilot } from '@/locales/fr-FR/copilot';
import { home } from '@/locales/fr-FR/home';
import { assistant } from '@/locales/fr-FR/assistant';
import { activity } from '@/locales/fr-FR/activity';
import { schedule } from '@/locales/fr-FR/schedule';
import { sites } from '@/locales/fr-FR/sites';
import { timeline } from '@/locales/fr-FR/timeline';
import { compliance } from '@/locales/fr-FR/compliance';
import { guide } from '@/locales/fr-FR/guide';
import { packs } from '@/locales/fr-FR/packs';
import { notifications } from '@/locales/fr-FR/notifications';
import { enUSResources } from '@/locales/en-US';
import { mergeLocaleResources } from '@/locales/mergeLocaleResources';

export const frFRResources = mergeLocaleResources(enUSResources, {
  common,
  auth,
  navigation,
  profile,
  workspace,
  billing,
  work,
  assets,
  inspections,
  jobs,
  lifecycleGate,
  contacts,
  copilot,
  home,
  assistant,
  activity,
  schedule,
  sites,
  timeline,
  compliance,
  guide,
  packs,
  notifications,
} as const);
